/**
 * The API host of a pull request preview: the app branch `pr-<n>` of Pages
 * serves at `pr-<n>.app-256.pages.dev`, and its API is the alias `pr-<n>` of
 * the Worker `api-preview`. Any other host has no preview API.
 */
export function getPreviewApiHost(hostname: string) {
  const match = /^pr-(\d+)\.app-256\.pages\.dev$/.exec(hostname.toLowerCase());
  return match
    ? `pr-${match[1]}-api-preview.vrplatform.workers.dev`
    : undefined;
}
